import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "checkRed",
  "use": "checkRed-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"checkRed\"><defs><style></style></defs><path d=\"M983.814 313.328a511.939 511.939 0 1040.115 198.632 511.939 511.939 0 00-40.115-198.632z\" fill=\"#d81e06\" data-spm-anchor-id=\"a313x.7781069.0.i7\" class=\"selected\" /><path d=\"M783.052 413.79L481.254 711.003a51.03 51.03 0 01-71.876-.328l-155.2-155.63a51.03 51.03 0 1172.265-72.08l119.385 119.691 265.593-261.6a51.05 51.05 0 1171.672 72.715z\" fill=\"#FCFCFC\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol